<template>
  <div class="card card-profile card-event">
    <a
      class="btn btn-xs btn-white btn-icon pos-absolute r-10 t-10"
      @click="modalShow = true"
    >
      <feather type="layers"></feather>
    </a>
    <img
      v-if="coverUrl != ''"
      :key="coverKey"
      :src="
        `assets/img/${
          $store.state.app.activeGroup.id == 9241 ||
          $store.state.app.activeGroup.id == 9249
            ? 'covers'
            : 'cover'
        }/${coverUrl}.png`
      "
      class="card-img-top"
      alt=""
    />
    <div class="card-body tx-13 pd-y-10-f">
      <div class="avatar wd-140 ht-140 mt-n80px pos-relative">
        <!-- <img    :src="`${$store.state.user.userInfo.avator}`" class="rounded-circle img-thumbnail border-0" alt=""> -->
        <img
          :src="`${$store.state.user.userInfo.avator + '?w=144'}`"
          class="rounded-circle img-thumbnail border-0 pd-0-f"
          alt=""
        />
        <!-- <div class="pos-absolute r-55 b-0">
            <simple-uploader :propObjectId="6" :propObjectTypeId="6" @on-success="avatorUploaded($event)">
              <a class="btn- btn-icon btn-xs btn-white" role="button">
                <feather type="image"></feather>
              </a>
            </simple-uploader>
          </div> -->
      </div>
      <div class="ht-50 align-items-start mg-l-150 pd-l-10">
        <div class="d-flex align-items-center wd-100p">
          <div>
            <h6>
              <a>{{ $store.state.user.userInfo.fullName }}</a>
            </h6>
            <p  v-if="!$store.state.app.isMobile"
              class="mg-b-0 text-truncate"
              style="max-width: 450px"
              :title="
                `${$store.state.user.userInfo.depart} ${$store.state.user.userInfo.position}`
              "
            >
              {{ $store.state.user.userInfo.depart }}
              {{ $store.state.user.userInfo.position }}
            </p>
          </div>
          <div class="mg-l-auto">
            <router-link
              v-if="$store.state.app.isMobile"
              :to="{ name: 'userProfile' }"
              class="go-step-2 btn btn-xs btn-uppercase btn-primary"
            >
              <feather type="user"></feather>
            </router-link>
            <router-link
              v-else-if="$store.state.app.activeGroup.id != 9249"
              :to="{ name: 'userProfile' }"
              class="go-step-2 btn btn-xs btn-uppercase btn-primary"
            >
              Мэдээлэл шинэчлэх
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="modalShow" size="xl" hide-footer hide-header>
      <h4 class="tx-18 tx-sm-20 mg-b-3">Ковер зураг солих</h4>
      <div class="container">
        <div class="row">
          <div
            @click="changeCover(c)"
            v-for="c in 4"
            :key="c"
            class="col-xs-6 col-sm-6 mg-b-10"
            role="button"
          >
            <img
              :src="
                `assets/img/${
                  $store.state.app.activeGroup.id == 9241 ||
                  $store.state.app.activeGroup.id == 9249
                    ? 'covers'
                    : 'cover'
                }/${c}.png`
              "
              class="wd-100p"
            />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { mapActions } from "vuex";

export default {
  components: {
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      coverUrl: "",
      coverKey: 0,
      modalShow: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["handleUsersettings"]),
    init() {
      let _arr = this.$store.state.app.userSettings.filter(
        x => x.key == "cover"
      );
      if (_arr.length > 0) {
        this.coverUrl = _arr[0].value;
      } else {
        this.coverUrl = "1";
      }
      this.coverKey++;
    },
    avatorUploaded() {},
    changeCover(c) {
      //console.log('changeCover', c);
      request({
        api: { method: "POST", url: "Config/EditPersonalSettings" },
        data: { key: "cover", name: "Ковер", value: c },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.handleUsersettings({ store: this.$store }).then(res => {
            if (res != false) {
              this.modalShow = false;
              this.init();
            }
          });
        }
      });
    }
  }
};
</script>

<style></style>
